import { FileDirectoryOpenFillIcon, GearIcon, StarIcon, TasklistIcon, StackIcon  } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NguonBietToiPage from "../crm-category/dm_nguonbiettoi";

import Noitru from "./NoiTru";

import Phong from "./phong";
import PhongHocSinh from "./phong-hocsinh";
import TrangThaiNoiTru from "./trang-thai";

const NoiTruLayout = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const selectedTab = useMemo(() => {
    if (tab === "phong") return "phong";
    if (tab === "phonghocsinh") return "phonghocsinh";
    if (tab === "trangthai") return "trangthai";

    return "noi-tru";
  }, [tab]);
  return (
    <Box>
      <UnderlineNav aria-label="tabs">
        <UnderlineNav.Item
          icon={TasklistIcon }
          aria-current={selectedTab === "noi-tru" ? "page" : undefined}
          onClick={() => {
            navigate(`../../noi-tru/noitru`);
          }}
        >
          Danh sách
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={StackIcon    }
          aria-current={selectedTab === "phonghocsinh" ? "page" : undefined}
          onClick={() => {
            navigate(`../../noi-tru/phonghocsinh`);
          }}
        >
          Phòng - Học sinh
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={FileDirectoryOpenFillIcon    }
          aria-current={selectedTab === "phong" ? "page" : undefined}
          onClick={() => {
            navigate(`../../noi-tru/phong`);
          }}
        >
          Phòng
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={FileDirectoryOpenFillIcon    }
          aria-current={selectedTab === "trangthai" ? "page" : undefined}
          onClick={() => {
            navigate(`../../noi-tru/trangthai`);
          }}
        >
          Trạng thái
        </UnderlineNav.Item>
      </UnderlineNav>
      <Box>{selectedTab === "noi-tru" && <Noitru />}</Box>
      <Box>{selectedTab === "phonghocsinh" && <PhongHocSinh />}</Box>
      <Box>{selectedTab === "phong" && <Phong />}</Box>
      <Box>{selectedTab === "trangthai" && <TrangThaiNoiTru />}</Box>

    </Box>
  );
};

export default NoiTruLayout;
